/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Search_Users_TeamsInputs */



/**
* | output |
* | --- |
* | "Search users or teams..." |
*
* @param {Spaces_Search_Users_TeamsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_search_users_teams = /** @type {((inputs?: Spaces_Search_Users_TeamsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Search_Users_TeamsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzer oder Teams suchen...")
	return /** @type {LocalizedString} */ ("Search users or teams...")
});